import { useState, useEffect } from "react";

// Helper to extract roles from localStorage
const getRolesFromLocalStorage = () => {
  try {
    const userString = localStorage.getItem("user");
    if (!userString) return [];
    const user = JSON.parse(userString);
    if (!user) return [];

    let accountRoles = [];
    if (user.account_roles) {
      if (Array.isArray(user.account_roles)) {
        accountRoles = user.account_roles
          .map((role) => role?.name)
          .filter(Boolean);
      } else if (user.account_roles.name) {
        accountRoles = [user.account_roles.name];
      }
    }

    let externalRoles = [];
    if (user.external_role) {
      if (Array.isArray(user.external_role)) {
        externalRoles = user.external_role
          .map((role) => role?.name)
          .filter(Boolean);
      } else if (user.external_role.name) {
        externalRoles = [user.external_role.name];
      }
    }

    return [...accountRoles, ...externalRoles].filter(Boolean);
  } catch (error) {
    console.error("Error processing roles:", error);
    return [];
  }
};

const getPositionFromLocalStorage = () => {
  try {
    const userString = localStorage.getItem("user");
    if (!userString) return null;
    const user = JSON.parse(userString);
    if (!user || !user.account_position) return null;

    return user.account_position.name || null;
  } catch (error) {
    console.error("Error processing position:", error);
    return null;
  }
};

const useRoles = () => {
  const [roles, setRoles] = useState(getRolesFromLocalStorage());
  const [position, setPosition] = useState(getPositionFromLocalStorage());

  useEffect(() => {
    if (roles.length === 0) {
      setRoles(getRolesFromLocalStorage());
    }
  }, []); // Only run on mount

  return { roles, position };
};

export default useRoles;
